// Ícone "?" com popover explicativo — clique abre/fecha (funciona no touch), clique fora fecha.
import { useEffect, useRef, useState } from 'react';
import { HelpCircle } from 'lucide-react';

interface Props {
  titulo?: string;
  texto: string;
}

export default function Dica({ titulo, texto }: Props) {
  const [aberto, setAberto] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!aberto) return;
    const fecha = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setAberto(false);
    };
    document.addEventListener('click', fecha);
    return () => document.removeEventListener('click', fecha);
  }, [aberto]);

  return (
    <span ref={ref} className="dica" onClick={(e) => e.stopPropagation()}>
      <button type="button" aria-label={titulo ? `O que é ${titulo}?` : 'O que é este card?'} onClick={() => setAberto((a) => !a)}>
        <HelpCircle size={14} />
      </button>
      {aberto && (
        <span className="dica-pop">
          {titulo && <strong>{titulo}</strong>}
          {texto}
        </span>
      )}
    </span>
  );
}
